import { TowTruckIcon } from './TowTruckIcon';

/**
 * author: Google
 * id BC8926AA-02C6-4755-B5A8-D3BD29C2CDE0
 * name tow-truck
 * version: 2.1.19
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/tow-truck.svg
 * tags
 * - Transportation + Road 
 */
export const AutoTowingIcon = TowTruckIcon;
export default AutoTowingIcon